import React from 'react';
import { FinalButton } from '../FinalButton';
import { useProviderNetworkContext } from './ProviderNetworkContext';

export const LoadMoreProviders = () => {
  const { hasMore, loadMore, batchedIntakeAvailabilityLoading } = useProviderNetworkContext();
  if (!hasMore) return null;
  return (
    <div className="flex justify-center pv3">
      <FinalButton
        kind="outline_black"
        onClick={loadMore}
        disabled={batchedIntakeAvailabilityLoading}
        loading={batchedIntakeAvailabilityLoading}
      >
        Load more providers
      </FinalButton>
    </div>
  );
};
